import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TopNav({ theme, setTheme, leftSlot = null }) {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  const switchLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-30 flex items-center justify-between px-6"
      style={{
        height: 56,
        backgroundColor: '#003399',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      {/* Left: (mobile hamburger) + Logo */}
      <div className="flex items-center gap-2">
        {leftSlot}
        <Link to="/app" className="no-underline">
          <span
            className="font-headline font-extrabold text-white uppercase"
            style={{ fontSize: 20, letterSpacing: '-0.5px' }}
          >
            VERIPASS
          </span>
        </Link>
      </div>

      {/* Right: Language toggle + Dark mode */}
      <div className="flex items-center gap-4">
        {/* Language toggle pill */}
        <div
          className="flex items-center"
          style={{
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 20,
            padding: 2,
          }}
        >
          <button
            onClick={() => switchLang('ko')}
            className="font-label font-bold text-xs transition-all"
            style={{
              padding: '4px 12px',
              borderRadius: 20,
              background: isKo ? '#a100aa' : 'transparent',
              color: isKo ? '#fff' : 'rgba(255,255,255,0.5)',
            }}
          >
            KR
          </button>
          <button
            onClick={() => switchLang('en')}
            className="font-label font-bold text-xs transition-all"
            style={{
              padding: '4px 12px',
              borderRadius: 20,
              background: !isKo ? '#a100aa' : 'transparent',
              color: !isKo ? '#fff' : 'rgba(255,255,255,0.5)',
            }}
          >
            EN
          </button>
        </div>

        {/* Dark mode icon */}
        <button
          onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
          className="flex items-center justify-center"
          style={{ color: 'rgba(255,255,255,0.7)' }}
          aria-label="Toggle dark mode"
        >
          <span className="material-symbols-outlined" style={{ fontSize: 22 }}>
            {theme === 'dark' ? 'light_mode' : 'dark_mode'}
          </span>
        </button>
      </div>
    </header>
  );
}
